import React, { useEffect, useState } from 'react'

export const useCallbackWhenVisible = (
  ref: React.RefObject<HTMLElement>,
  callBack: (pathName: string) => void,
): void => {
  const [isVisible, setIsVisible] = useState(false)
  const [observer, setObserver] = useState<IntersectionObserver>()

  useEffect(() => {
    const threshold = 0.8
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        setIsVisible(entries[0].intersectionRatio >= threshold)
      },
      { threshold },
    )
    setObserver(intersectionObserver)

    return () => intersectionObserver.disconnect()
  }, [])

  useEffect(() => {
    if (!observer || !ref.current) return
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [ref.current, observer])

  useEffect(() => {
    if (!isVisible || !window.dataLayer) return
    callBack(window.location.pathname)
  }, [isVisible])
}
